import { render, staticRenderFns } from "./ResidentTable.vue?vue&type=template&id=8160d354&scoped=true&lang=pug"
import script from "./ResidentTable.vue?vue&type=script&lang=ts"
export * from "./ResidentTable.vue?vue&type=script&lang=ts"
import style0 from "./ResidentTable.vue?vue&type=style&index=0&id=8160d354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8160d354",
  null
  
)

export default component.exports